import React from "react";
import { useParams } from "react-router";
import CodeAttempts from "../../Components/code-attempts/CodeAttempts";

export default function UserPage() {
  const { userId } = useParams();
  return <CodeAttempts userId={userId} />;
}
